import React from "react";
import CabiMascot from "./CabiMascot";
import Button from "./Button";

/**
 * Friendly empty / error / permission / offline state: Cabi (or an emoji) +
 * a reason + one CTA. Used for "no data yet", camera denied, feature gated
 * by plan, offline, and generic request-failed screens — same shape, only
 * the copy/mood/cta differ per call site. Presentational only: the caller
 * decides *when* to render this from its own real empty/error condition.
 */
export default function EmptyState({
  mood = "thinking",
  emoji,
  title,
  subtitle,
  cta,
  onCta,
  theme = "light",
  className = "",
}) {
  const onLight = theme === "light";

  return (
    <div className={`flex flex-col items-center justify-center text-center gap-3 px-6 py-10 ${className}`}>
      {emoji ? (
        <span className="text-5xl leading-none">{emoji}</span>
      ) : (
        <CabiMascot mood={mood} size={90} />
      )}
      <h3
        className="font-display font-semibold text-[19px]"
        style={{ color: onLight ? "#2A2620" : "#fff" }}
      >
        {title}
      </h3>
      {subtitle && (
        <p
          className="font-body font-bold text-[14px] max-w-xs"
          style={{ color: onLight ? "#8A7E72" : "rgba(255,255,255,.85)" }}
        >
          {subtitle}
        </p>
      )}
      {cta && (
        <Button variant="primary" onClick={onCta} className="mt-1">
          {cta}
        </Button>
      )}
    </div>
  );
}
